module.exports = __webpack_public_path__ + "img/concertHall-4.8ee4b218.png";